"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApRiskWidget = void 0;
var React = require("react");
var ApLoaderDefault_1 = require("../../ApLoaderDefault");
var ApLoaderText_1 = require("../../ApLoaderText");
var ApWidgetBigValue_1 = require("../ApWidgetBigValue");
var ApWidgetCard_1 = require("../ApWidgetCard");
var ApWidgetErrorMessage_1 = require("../ApWidgetErrorMessage");
var ApWidgetMidValue_1 = require("../ApWidgetMidValue");
var ApWidgetName_1 = require("../ApWidgetName");
var styles_1 = require("./styles");
exports.ApRiskWidget = function (_a) {
    var data = _a.data, dataError = _a.dataError, config = _a.config, props = __rest(_a, ["data", "dataError", "config"]);
    return (React.createElement(ApWidgetCard_1.ApWidgetCard, __assign({}, props),
        React.createElement(styles_1.StyledWidgetWrapper, null,
            config && (React.createElement(ApWidgetName_1.ApWidgetName, { name: config.name, iconType: config.iconType })),
            dataError ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApWidgetErrorMessage_1.ApWidgetErrorMessage, null))) : !data ? (React.createElement(styles_1.StyledWidgetBody, null,
                React.createElement(ApLoaderDefault_1.ApLoaderDefault, { loaderText: function () { return React.createElement(ApLoaderText_1.ApLoaderText, null); } }))) : (React.createElement(styles_1.Container, null, (config && config.widthRatio === 1 ? data.slice(0, 1) : data).map(function (_a, index) {
                var category = _a.category, spend = _a.spend, value = _a.value, type = _a.type, message = _a.message;
                return (React.createElement(styles_1.Section, { key: index },
                    React.createElement(styles_1.Title, null,
                        type === 'high' ? 'over' : 'only',
                        ' ',
                        React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, { size: "s" }, value),
                        " for",
                        ' ',
                        React.createElement(ApWidgetBigValue_1.ApWidgetBigValue, { size: "s" }, spend),
                        " in",
                        ' ',
                        React.createElement(ApWidgetMidValue_1.ApWidgetMidValue, null, category)),
                    React.createElement(styles_1.StyledNotification, null, message)));
            }))))));
};
exports.ApRiskWidget.defaultProps = {
    config: {
        name: '',
    },
    data: null,
};
//# sourceMappingURL=ApRiskWidget.js.map